// Contact sales, for a band with no listed price: the paywall (PricingGate)
// and the Plans page (BillingControls). Hands the merchant to their mail
// client — a request of ours never sees that, so the click is recorded here.

import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { trackEvent } from '../../hooks/useTracking';
import { openMailto } from '../../utils/mailto';
import { contactSalesMailto } from './planCopy';

/** @param {string} salesEmail  `prices.sales_email`, the backend's one source */
export default function ContactSalesButton({ salesEmail }) {
  const { t } = useTranslation();
  const open = () => {
    trackEvent('sales_contact_opened');
    openMailto(contactSalesMailto(t, salesEmail));
  };
  return (
    <Button variant="contained" onClick={open}>
      {t('billing.contactSalesCta')}
    </Button>
  );
}
